(function (angular) {
  "use strict";

  angular.module("app").service("handleError", handleError);

  handleError.$inject = ["alerts"];

  function handleError(alerts) {
    var _this = this,
      statusMessages = {
        400: "Request not understood",
        401: "Unauthorised",
        402: "This is a premium service",
        403: "Not allowed to do that",
        404: "Couldn't find what you asked for",
        405: "Method not allowed",
        406: "Not acceptable",
        407: "Proxy authentication required first",
        408: "Request took too long",
        409: "Conflicting request",
        410: "Data is no longer here",
        413: "Request was too large",
        422: "Request couldn't be processed",
        429: "Too many requests in a short period of time",
        500: "There was an error on the server",
      };

    /**
     * Outputs error to the console
     * @param  {[type]} error [description]
     * @return {[type]}       [description]
     */
    this.console = function (error) {
      console.warn(error.messages[0], error);
    };

    this.alert = function (alert) {
      alerts.emit(alert);
    };

    /**
     * Extracts a usable error object from whatever is provided to handle(), with a suggested next action
     * @param  {mixed} error - error object
     * @return {object}      - {messages: ['Something'], title: 'Error', action: 'alert'}
     */
    function distill(error) {
      var obj: Record<string, any> = {
        action: "alert",
        title: "Error",
        messages: [],
      };

      // http object
      if (error.headers && error.status && error.data) {
        obj.action = "alert";

        obj.title = statusMessages[error.status] || error.statusText;

        angular.forEach(error.data, function (msg) {
          if (Array.isArray(msg)) {
            obj.messages.push(msg[0]);
          } else {
            obj.messages.push(msg);
          }
        });

        if (error.status >= 400) {
          obj.theme = "error";
        }

        return obj;
      }

      // Custom single message
      if (error.message) {
        obj.messages[0] = error.message;
        return obj;
      }

      // Custom multiple messages
      if (error.messages) {
        angular.forEach(error.messages, function (msg) {
          obj.messages.push(msg);
        });
        return obj;
      }

      // No idea what this is...
      obj.messages[0] = "Unknown error";
      obj.originalError = error;

      return obj;
    }

    /**
     * Decides what to do with an error
     * @param  {mixed} error - error to do something with
     * @param {string} forceEvent - specify what to do with this error, instead of trying to guess
     * @return {promise}
     */
    function handle(errorInput, forceEvent) {
      var error = distill(errorInput);

      _this[forceEvent || error.action](error);
    }

    return handle;
  }
})(angular);
